import { render, staticRenderFns } from "./TreeNodeDetails.vue?vue&type=template&id=72aa43a2"
import script from "./TreeNodeDetails.vue?vue&type=script&lang=js"
export * from "./TreeNodeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports